<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <span class="card-title wise-card-title">리포트 서베이 등록</span>
          </div>
          <b-row class="pt-2">
            <b-col sm="12">
              <table class="table table-bordered oddBackground">
                <tbody>
                  <tr>
                    <td style="width:20%; vertical-align: middle;">리포트 서베이 명</td>
                    <td class="tl">
                      <input type="text" v-model="queryParams.survey_name" style="width: 90%;" class="form-control" />
                    </td>
                  </tr>
                  <tr>
                    <td style="width:20%; vertical-align: middle;">썸네일1</td>
                    <td class="tl">
                      <div style="border:1px solid #c2cfd6; border-radius:4px; display:inline-block;">
                        <input type="file" class="form-control-file" ref="thumbnail1" accept=".jpg,.jpeg,.png" style="padding:5px" @change="onThumbnail1Change" />
                      </div>
                      <div style="float:left" class="imgview" :data="item.file_url" v-for="(item, idx) in thumbnail1Files" :key="'thumb1-'+idx">
                        등록된 파일 : {{item.file_originalname || item.name}} <span v-if="item.filesizeStr">({{item.filesizeStr}})</span>
                        <button @click="delThumbnailFile(1, idx)" style="margin-left:10px">삭제</button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:20%; vertical-align: middle;">썸네일2</td>
                    <td class="tl">
                      <div style="border:1px solid #c2cfd6; border-radius:4px; display:inline-block;">
                        <input type="file" class="form-control-file" ref="thumbnail2" accept=".jpg,.jpeg,.png" style="padding:5px" @change="onThumbnail2Change" />
                      </div>
                      <div style="float:left" class="imgview" :data="item.file_url" v-for="(item, idx) in thumbnail2Files" :key="'thumb2-'+idx">
                        등록된 파일 : {{item.file_originalname || item.name}} <span v-if="item.filesizeStr">({{item.filesizeStr}})</span>
                        <button @click="delThumbnailFile(2, idx)" style="margin-left:10px">삭제</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <div slot="header">
            <span class="card-title wise-card-title">적용상품</span>
            <b-button variant="primary" style="float: right;" v-on:click="openProductInfoModal()">상품검색</b-button>
          </div>
          <b-row>
            <b-col sm="12">
              <table class="table table-bordered oddBackground">
                <tbody>
                  <tr>
                    <td style="width:10%; vertical-align: middle;">보고서번호</td>
                    <td class="tl" style="width:15%;">
                      {{productInfoOptions.dr_code}}
                    </td>
                    <td style="width:10%; vertical-align: middle;">보고서명</td>
                    <td class="tl" style="width:35%;">
                      {{productInfoOptions.report_name}}
                    </td>
                    <td style="width:15%; vertical-align: middle;">사용권한(다운로드양식)</td>
                    <td class="tl" style="width:20%;">
                        일반 PDF 파일
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card>

        <b-row class="mt-3" style="float:right">
          <b-col>
            <!-- <b-button variant="success" v-on:click="saveReportSurvey" style="color:#ffffff; border-radius:5px; cursor:pointer; width:120px; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px">저장</h5></b-button> -->

            <b-button variant="success"
                      v-if="formType === 'insert'"
                      v-on:click="saveReportSurvey()"
                      :disabled="isButtonDisabled"
                      style="color:#ffffff; border-radius:5px; cursor:pointer; width:120px; border:1px solid #248847; font-size:15px">
              <h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5>
            </b-button>
            <b-button variant="success" 
                      v-else v-on:click="saveReportSurvey()" 
                      style="color:#ffffff; border-radius:5px; cursor:pointer; width:120px; border:1px solid #248847; font-size:15px">
              <h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 수정</h5>
            </b-button>
          </b-col>
          <b-col>
            <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:120px; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/contents/reportSurveyManagement'">목록</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- 상품검색 모달 -->
    <b-modal title="보고서 상품 검색" size="xl" v-model="productFormModal" @ok="productFormModal = false"
    no-close-on-backdrop no-close-on-esc hide-footer>
      <reportOptModal v-bind:reportOptions="reportOptions" v-bind:productFormModal="productFormModal" @childs-event="productModalClose" ref="reportOptModalRef"></reportOptModal>
    </b-modal>
  </div>
</template>
<script>
import reportOptModal from '../../order/ReportOptModal.vue';
import swal from 'sweetalert2';

export default {
  name: 'ReportSurveyForm',
  components: {
    reportOptModal,
  },
  data() {
    return {
      queryParams: {
        survey_name: '',
        survey_code: '',
        dr_code: '',
        report_name: '',
        attachmentFileItems:[],
      },
      thumbnail1Files: [], // [{file_originalname, filesizeStr, ...}]
      thumbnail2Files: [],
      productInfoOptions: {
        price: 0,
        custom_start_date: '',
        custom_end_date: '',
        op_code: '', //보고서 코드
        op_name: '', //보고서 이름
        dr_code: '',      //보고서 코드
        dr_type_code: '', //보고서 타입 코드
        opt_code: '',     //옵션 코드
        opt_file_type: '',//옵션 파일 타입
        name: '',         //보고서 옵션명
        report_name: '',  //보고서 명
        type: '',         //옵션 타입
        exposure: '',     //옵션 순서
        security_price: 0,
        normal_price: 0,
      },
      reportOptions: {
        optItems: [],
        pkgItems: [],
      },
      productFormModal: false,
      isButtonDisabled: false,
      formType: 'insert', // 추가: 폼 타입 (insert/update)
      survey_code: '', // 추가: 현재 수정중인 survey_code
    }
  },
  created() {
    // 수정 모드 분기
    if (this.$route.query.survey_code) {
      this.formType = 'update';
      this.survey_code = this.$route.query.survey_code;
      this.fetchSurveyData();
    }
  },
  methods: {
    fetchSurveyData() {
      // 단건 조회 API 호출 (예시: /api/select/reportSurveyData?survey_code=xxx)
      const token = sessionStorage.getItem("myToken");
      const self = this;
      self.$http.get('/api/select/reportSurvey?access_token=' + token + '&surveyCode=' + self.survey_code)
        .then((result) => {
          console.log(result.data);

          self.queryParams = result.data;
          
          // attachmentFileItems에서 file_sequence에 따라 썸네일 분류
          if (result.data.attachmentFileItems && result.data.attachmentFileItems.length > 0) {
            result.data.attachmentFileItems.forEach(item => {
              console.log(item);
              if (item.file_sequence === '1') {
                self.thumbnail1Files = [item];
              } else if (item.file_sequence === '2') {
                self.thumbnail2Files = [item];
              }
            });
          }
          
          // 상품 정보도 세팅 (있으면)
          if (result.data.dr_code || result.data.report_name) {
            self.productInfoOptions.dr_code = result.data.dr_code;
            self.productInfoOptions.report_name = result.data.report_name;
          }
        });
    },
    onThumbnail1Change(e) {
      console.log('onThumbnail1Change > ', e);
      const file = e.target.files[0];
      console.log('file > ', file);
      if (file) {
        this.thumbnail1Files = [file];
      }
    },
    onThumbnail2Change(e) {
      const file = e.target.files[0];
      if (file) {
        this.thumbnail2Files = [file];
      }
    },
    delThumbnailFile(type, idx) {
      if (type === 1) {
        this.thumbnail1Files.splice(idx, 1);
      } else if (type === 2) {
        this.thumbnail2Files.splice(idx, 1);
      }
    },
    saveReportSurvey() {
      var self = this;

      if (self.queryParams.survey_name === '') {
        swal.fire({
          type: 'error',
          title: '서베이 명을 입력해 주세요.',
          showConfirmButton: false
        });
        return false;
      }

      if (self.productInfoOptions.dr_code === '') {
        swal.fire({
          type: 'error',
          title: '상품을 선택해 주세요.',
          showConfirmButton: false
        });
        return false;
      }

      if (!this.isButtonDisabled) {
        this.isButtonDisabled = true;

        const data = new FormData();
        const token = sessionStorage.getItem("myToken");

        // 기본 데이터 설정
        self.queryParams.reg_id = self.$session.get('userId');
        self.queryParams.survey_name = self.queryParams.survey_name;
        self.queryParams.dr_code = self.productInfoOptions.dr_code;
        self.queryParams.report_name = self.productInfoOptions.report_name;

        // 썸네일 파일 추가
        if (this.thumbnail1Files.length > 0) {
          data.append('thumbnailFile1', this.thumbnail1Files[0]);
        }
        if (this.thumbnail2Files.length > 0) {
          data.append('thumbnailFile2', this.thumbnail2Files[0]);
        }

        // JSON 데이터를 FormData에 추가
        const param = encodeURI(JSON.stringify(self.queryParams));
        data.append('objs', param);

        // API 호출 분기
        if (this.formType === 'update') {
          // 수정 API (예시: /api/update/reportSurvey)
          self.$http.post('/api/update/reportSurvey?access_token=' + token, data, null)
            .then((result) => {
              if (result.data === 'error') {
                this.isButtonDisabled = false;
                swal.fire({
                  type: 'error',
                  title: '리포트 서베이 수정이 실패했습니다.',
                  showConfirmButton: false,
                  timer: 1500
                });
              } else {
                swal.fire({
                  type: 'success',
                  title: '리포트 서베이가 수정되었습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                  window.location = "#/contents/reportSurveyManagement";
                });
              }
            })
            .catch(error => {
              this.isButtonDisabled = false;
              swal.fire({
                type: 'error',
                title: '리포트 서베이 수정이 실패했습니다.',
                showConfirmButton: false,
                timer: 1500
              });
            });
        } else {
          // 등록 API (기존과 동일)
          self.$http.post('/api/insert/reportSurvey?access_token=' + token, data, null)
            .then((result) => {
              if (result.data === 'error') {
                this.isButtonDisabled = false;
                swal.fire({
                  type: 'error',
                  title: '리포트 서베이 등록이 실패했습니다.',
                  showConfirmButton: false,
                  timer: 1500
                });
              } else {
                swal.fire({
                  type: 'success',
                  title: '리포트 서베이가 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                  window.location = "#/contents/reportSurveyManagement";
                });
              }
            })
            .catch(error => {
              this.isButtonDisabled = false;
              swal.fire({
                type: 'error',
                title: '리포트 서베이 등록이 실패했습니다.',
                showConfirmButton: false,
                timer: 1500
              });
            });
        }
      }
    },
    openProductInfoModal() {
      var self = this;
      self.productFormModal = true;
    },
    productModalClose(productdata) {
      console.log('productdata', productdata);
      var self = this;
      self.productInfoOptions = {
        price: 0,
        custom_start_date: '',
        custom_end_date: '',
        op_code: '', //보고서 코드
        op_name: '', //보고서 이름
        dr_code: '',      //보고서 코드
        dr_type_code: '', //보고서 타입 코드
        opt_code: '',     //옵션 코드
        opt_file_type: '',//옵션 파일 타입
        name: '',         //보고서 옵션명
        report_name: '',  //보고서 명
        type: '',         //옵션 타입
        exposure: '',     //옵션 순서
        security_price: 0,
        normal_price: 0,
      };
      
      self.productInfoOptions = productdata;
      self.productFormModal = false;
    }
  }
}

$(document).ready(function(){
	var xOffset = 50;
  var yOffset = 10;
  $(document).on("mouseover",".imgview",function(e){ //마우스 오버시
      $("body").append("<p id='preview'><img style='width:100px; height:100px;' src='"+ $(this).attr("data") +"'/></p>"); //보여줄 이미지를 선언
      $("#preview")
          .css("position","absolute")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px")
          .css("width", "100px")
          .css("height", "100px")
          .fadeIn("fast"); //미리보기 화면 설정 셋팅
  });
  $(document).on("mousemove",".imgview",function(e){ //마우스 이동시
      $("#preview")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px")
          .css("width", "100px")
          .css("height", "100px")
  });
  $(document).on("mouseout",".imgview",function(){ //마우스 아웃시
      $("#preview").remove();
  });
});
</script>
<style scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
}
</style> 


// WEBPACK FOOTER //
// src/views/contents/reportSurvey/ReportSurveyForm.vue